module.exports = __webpack_public_path__ + "img/Icon-Blog4.cac65a73.png";